module.exports = __webpack_public_path__ + "static/img/post3_tiny.d65801a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/post3_tiny.jpg
// module id = yPHR
// module chunks = 192